import styled from 'styled-components';

export const Wrapper = styled.div`
	padding: 12px;
	width: 100%;
	height: 112px;
	border-radius: 12px;
	background: ${({ theme }) => theme.gradient.backgroundProfile};
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	overflow: hidden;
	position: relative;
	border: 1px solid ${({ theme }) => theme.colors.control.darkPressed};

	@media (max-width: 1100px) {
		width: 100%;
	}
`;

export const BgImage = styled.img`
	position: absolute;
	top: 0;
	right: 0;
	mix-blend-mode: lighten;
`;

export const Title = styled.h2`
	font-size: 16px;
	line-height: 22px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.subtitle};
`;

export const Link = styled.div`
	font-size: 13px;
	line-height: 18px;
	font-weight: 600;
	color: ${({ theme }) => theme.colors.text.alwaysWhite};
	position: relative;

	svg {
		position: absolute;
		width: 20px;
		height: 20px;

		path {
			fill: ${({ theme }) => theme.colors.text.alwaysWhite};
		}
	}
`;
